
export class CalcoloInteressiRequest {
  dataInizioCalcolo: string;
  dataFineCalcolo: string;
  valore: any;
  fineCalcoloAdUltimoGiornoMese: boolean;
  capitalizzazione: boolean;
}
